import Montana from '../../Media/Logo Ciputra Cibubur/Montana.png'
import Monterrey from '../../Media/Logo Ciputra Cibubur/Monterrey.png'
import Monteverde from '../../Media/Logo Ciputra Cibubur/Monteverde.png'


const citralandimages =[
Montana,Monterrey,Monteverde
]

export default citralandimages;